import { Translate } from 'react-redux-i18n'
import { SampleReport } from './SampleReport'
import { ReportItem } from './reportItem'

export const Item = ({ item }) => {
  return (
    <div className="item">
      <div className="dFlex alignItemsCenter justifyContentBetween fw600 mb2">
        <Translate value={item.name} />
        <SampleReport id={item.fiinGateReportTypeId} />
      </div>

      <div className="px3 dFlex gap5">
        <ReportItem
          data={{
            name: item.name,
            hasReadyVersion: true,
            id: item.fiinGateReportTypeId,
            totalPrice: item.price,
            price: item.price - item.price * (item.discountPercentage || 0),
            availableData: item.availableData,
            deliveryDays: item.deliveryDays,
          }}
        />
        <ReportItem
          data={{
            name: item.name,
            isReadyToUseVersion: true,
            hasReadyVersion: item.hasReadyVersion,
            id: item.fiinGateReportTypeId,
            totalPrice: item.readyVersionPrice,
            price:
              item.readyVersionPrice -
              item.readyVersionPrice * (item.discountPercentage || 0),
            yearReport: item.readyVersionReportingYear,
            createdDate: item.readyVersionCreateDate,
          }}
        />
      </div>
    </div>
  )
}
